module.exports = __webpack_public_path__ + "media/7.242fc489.wav";